(function () {
  // Minimal implementation of Shopify's money_format placeholders, so currency
  // never depends on a global that may or may not be loaded.
  function group(intPart, sep) {
    return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function renderMoneyFormat(cents, moneyFormat) {
    const tpl = moneyFormat || (window.Shopify && Shopify.money_format) || '{{amount}}';
    const neg = cents < 0 ? '-' : '';
    const abs = Math.abs(cents) / 100;
    const fixed = abs.toFixed(2);
    const [int, dec] = fixed.split('.');
    const rounded = String(Math.round(abs));

    return tpl.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) => {
      switch (name) {
        case 'amount':
          return neg + group(int, ',') + '.' + dec;
        case 'amount_with_comma_separator':
          return neg + group(int, '.') + ',' + dec;
        case 'amount_no_decimals':
          return neg + group(rounded, ',');
        case 'amount_no_decimals_with_comma_separator':
          return neg + group(rounded, '.');
        case 'amount_with_apostrophe_separator':
          return neg + group(int, "'") + '.' + dec;
        case 'amount_no_decimals_with_space_separator':
          return neg + group(rounded, ' ');
        case 'amount_with_space_separator':
          return neg + group(int, ' ') + ',' + dec;
        default:
          return neg + group(int, ',') + '.' + dec;
      }
    });
  }

  function stripTrailingZeroCents(formatted, cents) {
    const value = Number(cents);
    if (!Number.isFinite(value) || value % 100 !== 0 || !formatted) return formatted;
    return formatted.replace(/,00(?!\d)/g, '').replace(/\.00(?!\d)/g, '');
  }

  function pickMoneyFormat(format) {
    if (format) return format;
    const shopify = window.Shopify && Shopify.money_format;
    const fox = window.FoxTheme?.settings?.moneyFormat;
    const theme = window.theme?.moneyFormat;
    const candidates = [shopify, fox, theme].filter(Boolean);
    // Prefer a format that still shows a currency after stripping amount placeholders.
    const withCurrency = candidates.find((tpl) =>
      /[€$£¥]|CHF|EUR|USD|GBP|Fr\.?\b|kr\b/i.test(String(tpl).replace(/\{\{\s*[\w]+\s*\}\}/g, ''))
    );
    return withCurrency || shopify || fox || theme || '{{amount_with_comma_separator}}';
  }

  function format(amount, format) {
    const cents = typeof amount === 'string' ? parseInt(amount.replace('.', ''), 10) : amount;
    const moneyFormat = pickMoneyFormat(format);
    let formatted;

    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      formatted = Shopify.formatMoney(cents, moneyFormat);
    } else if (Number.isFinite(cents)) {
      // Shopify.formatMoney is not present on every page, and the old fallback
      // hardcoded a euro sign. On CHF, USD or GBP markets that printed the right
      // number with the wrong currency. Render the shop's money_format instead.
      formatted = renderMoneyFormat(cents, moneyFormat);
    } else {
      formatted = '';
    }

    return stripTrailingZeroCents(formatted, cents);
  }

  window.EaseMoney = {
    format,
    stripTrailingZeroCents,
    renderMoneyFormat,
  };

  function patchThemeCurrency() {
    if (!window.FoxTheme?.Currency?.formatMoney || FoxTheme.Currency.formatMoney.__easePatched) return;
    const original = FoxTheme.Currency.formatMoney.bind(FoxTheme.Currency);
    const patched = function (cents, format) {
      return stripTrailingZeroCents(original(cents, format), cents);
    };
    patched.__easePatched = true;
    FoxTheme.Currency.formatMoney = patched;
  }

  patchThemeCurrency();
  document.addEventListener('DOMContentLoaded', patchThemeCurrency);
})();
